<template>
  <div v-if="!loading && event_owner">
    <h1 class="main-header">
      <translate translate-context="event_owners"
                 :translate-params="{id: event_owner.id, name: event_owner.company_name}">
        Event Owner #%{id} - %{name}
      </translate>
    </h1>

    <CCard>
      <CCardBody>
        <div class="detail-container">
          <div class="info-section mb-4">
            <h3 v-translate translate-context="event_owner">Event Owner Details</h3>
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label" v-translate>Company Name:</span>
                <span class="info-value">{{ event_owner.company_name }}</span>
              </div>
              <div class="info-item" v-if="event_owner.third_level_domain">
                <span class="info-label" v-translate>Domain:</span>
                <span class="info-value">{{ event_owner.third_level_domain }}</span>
              </div>
            </div>
          </div>

          <div class="navigation-section">
            <h3 v-translate translate-context="event_owner">Manage</h3>
            <div class="button-grid">
              <CButton
                color="info"
                size="lg"
                @click="navigateTo('event_owner.edit')"
                class="nav-button"
                v-if="hasPerm('event_owner.edit')">
                <CIcon name="cipPencil" class="mr-2"/>
                <span v-translate>Edit</span>
              </CButton>

              <CButton
                color="warning"
                size="lg"
                @click="navigateTo('eventOwner.emailTemplates.list')"
                class="nav-button"
                v-if="hasPerm('event_owner.email_template.list')">
                <CIcon name="cil-envelope-closed" class="mr-2"/>
                <span v-translate>Email Templates</span>
              </CButton>

              <CButton
                color="warning"
                size="lg"
                @click="navigateTo('eventOwner.emailSchedules.list')"
                class="nav-button"
                v-if="hasPerm('event_owner.email_scheduler.list')">
                <CIcon name="cil-calendar" class="mr-2"/>
                <span v-translate>Email Schedules</span>
              </CButton>
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound} from "@/domain/core/exception/exceptions";

export default {
  name: 'DetailEventOwner',
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchConfig({type: 'event_owner', id: this.$route.params.id}),
        this.fetchEventOwner(this.$route.params.id)
      ])
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'event_owner.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('eventOwner', [
      'event_owner',
    ]),
  },
  methods: {
    ...mapActions('eventOwner', [
      'fetchEventOwner',
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    navigateTo(routeName) {
      const params = { id: this.event_owner.id }

      // For email templates and schedules, use eventOwnerId
      if (routeName.includes('emailTemplates') || routeName.includes('emailSchedules')) {
        params.eventOwnerId = this.event_owner.id
        delete params.id
      }

      this.$router.push({
        name: routeName,
        params: params
      })
    }
  }
}
</script>

<style scoped>
.detail-container {
  padding: 1rem;
}

.info-section {
  border-bottom: 1px solid #e3e4e6;
  padding-bottom: 1.5rem;
}

.info-section h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.info-label {
  font-weight: 600;
  color: #636f83;
}

.info-value {
  color: #2c3e50;
}

.navigation-section h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.button-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.nav-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
  font-weight: 500;
  transition: all 0.2s;
}

.nav-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .button-grid {
    grid-template-columns: 1fr;
  }
}
</style>
